import { createApp } from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue';
import router from './router'
import store from './store'
import mqtt from '@/api/mqtt';
import 'ant-design-vue/dist/antd.css';
import './assets/font.css';

import ECharts from 'vue-echarts'
import { use } from "echarts/core";

// 手动引入 ECharts 各模块来减小打包体积
import {
    CanvasRenderer
} from 'echarts/renderers'
import {
    BarChart, LineChart, PieChart
} from 'echarts/charts'
import {
    GridComponent,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    ToolboxComponent,
    DatasetComponent,
} from 'echarts/components'


use([
    CanvasRenderer,
    BarChart,
    PieChart,
    LineChart,
    GridComponent,
    TooltipComponent,
    TitleComponent,
    LegendComponent,
    ToolboxComponent,
    DatasetComponent,
]);
mqtt.connect();
const app = createApp(App);
app.component('v-chart', ECharts);
app.use(router).use(store).use(Antd).mount('#app');
app.config.globalProperties.$provinceId = "1485"
app.config.globalProperties.$filters = {

    // 挂载全局属性  
    formatTime(e) {
        var date = new Date(e);
        var h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        var m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        return h + ":" + m;
    }
}

